import { usePreliminaryAuthUser } from './usePreliminaryAuthUser';

export const useIsPreliminaryAuth = () => !!usePreliminaryAuthUser();
